export default __webpack_public_path__ + "a26014f5010c527f3807d479ab555c38.png";